
export type UserRole = "Super User" | "Project Manager" | "Project Viewer" ;

export const isAccessAllowed = (role: UserRole): boolean => {
  const restrictedRoles: UserRole[] = ["Project Viewer"];
  return !restrictedRoles.includes(role);
};

// Delivery stages a Project Viewer may open; the quote stages before them stay hidden.
const viewerOpenableStatuses = ["Project Scheduled", "In Progress", "Report Available"];

// Statuses whose Canopy project (and so its report) the projects list links to.
export const hasReportLink = (status: string): boolean =>
  viewerOpenableStatuses.includes(status) || status === "Closed";

// "Closed" also covers deleted drafts and rejected quotes, which never had a Canopy project, so a
// closed project only opens for a viewer when it was actually delivered.
export const canViewerOpenProject = (status: string, canopyProjectId: number | null): boolean =>
  viewerOpenableStatuses.includes(status) || (status === "Closed" && canopyProjectId != null);

const retestEligibleStatuses = ["Report Available", "Closed"];

export const isRetestEligibleProjectStatus = (status: string): boolean => retestEligibleStatuses.includes(status);
